import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { logout } from '../../services/authService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faSignOut, faSignIn, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const Navbar = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const location = useLocation();

  if (location.pathname === '/login' || location.pathname === '/signup') return null;

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="bg-white shadow-lg py-3 sticky top-0 z-40 shadow-xl flex items-center justify-between px-6 sm:px-16 relative text-secondary">
      <div className="text-xl font-bold">
        <a href='/'>
          <img loading="lazy" src='/logo.png' className='w-40 sm:w-60' alt="Logo" />
        </a>
      </div>

      <div className="sm:hidden">
        <button onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none">
          {menuOpen ? <FontAwesomeIcon icon={faTimes} className="text-2xl" /> : <FontAwesomeIcon icon={faBars} className="text-2xl" />}
        </button>
      </div>

      <div className="hidden sm:flex justify-between items-center space-x-16">
        <ul className="flex space-x-16 items-center">

          <li><a href="/agencies" className="hover:text-primary">Find Agencies</a></li>
          <li><a href="/submit-agency" className="hover:text-primary">Submit Agency</a></li>
          {currentUser && <li><a href="/dashboard" className="hover:text-primary">Dashboard</a></li>}

          <li className="relative">
            <button
              onClick={() => setServicesOpen(!servicesOpen)}
              className="hover:text-primary flex items-center gap-1"
            >
              Services <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
            </button>

            {servicesOpen && (
              <div className="absolute top-full mt-3 w-44 bg-white shadow-lg border rounded-xl p-3 space-y-3 z-50">
                <a href="/consultation" className="block hover:text-primary">CRM Setup</a>
                <a href="/automation" className="block hover:text-primary">Automation</a>
                <a href="/automation-report" className="block hover:text-primary">Automation Report</a>
              </div>
            )}
          </li>

          <li><a href="/about" className="hover:text-primary">About Us</a></li>
          <li><a href="/newsletter" className="hover:text-primary">Newsletter</a></li>
          <li><a href="/blogs" className="hover:text-primary">Blogs</a></li>
        </ul>

        <div>
          {!currentUser ? (
            <button onClick={() => navigate('/login')}>
              <FontAwesomeIcon icon={faSignIn} className='text-primary hover:text-white hover:bg-primary p-2 rounded' />
            </button>
          ) : (
            <button onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOut} className='text-red-600 hover:text-white hover:bg-red-600 p-2 rounded' />
            </button>
          )}
        </div>
      </div>

      {menuOpen && (
        <div className="sm:hidden absolute top-full left-0 w-full bg-white shadow-lg z-50">
          <ul className="flex flex-col space-y-4 p-6">

            <li><a href="/agencies" className="hover:text-blue-500" onClick={() => setMenuOpen(false)}>Find Agencies</a></li>
            <li><a href="/submit-agency" className="hover:text-blue-500" onClick={() => setMenuOpen(false)}>Submit Agency</a></li>
            {currentUser && <li><a href="/dashboard" className="hover:text-blue-500" onClick={() => setMenuOpen(false)}>Dashboard</a></li>}

            <li>
              <button
                onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                className="w-full flex justify-between items-center hover:text-blue-500"
              >
                Services <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
              </button>

              {mobileServicesOpen && (
                <div className="mt-2 pl-4 space-y-3">
                  <a href="/consultation" onClick={() => setMenuOpen(false)} className="block hover:text-blue-500">CRM Setup</a>
                  <a href="/automation" onClick={() => setMenuOpen(false)} className="block hover:text-blue-500">Automation</a>
                  <a href="/automation-report" onClick={() => setMenuOpen(false)} className="block hover:text-blue-500">Automation Report</a>
                </div>
              )}
            </li>

            <li><a href="/about" className="hover:text-blue-500" onClick={() => setMenuOpen(false)}>About Us</a></li>
            <li><a href="/newsletter" className="hover:text-blue-500" onClick={() => setMenuOpen(false)}>Newsletter</a></li>
            <li><a href="/blogs" className="hover:text-blue-500" onClick={() => setMenuOpen(false)}>Blogs</a></li>

            <li>
              {!currentUser ? (
                <button
                  className="bg-primary text-white px-8 py-2 rounded-full hover:bg-blue-700 w-full"
                  onClick={() => { navigate('/login'); setMenuOpen(false); }}
                >
                  Sign In
                </button>
              ) : (
                <button
                  onClick={() => { handleLogout(); setMenuOpen(false); }}
                  className="px-4 py-2 bg-red-500 rounded text-white w-full"
                >
                  Logout
                </button>
              )}
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
